import { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [userType, setUserType] = useState(null)
  const [userData, setUserData] = useState(null)

  useEffect(() => {
    const storedAuth = localStorage.getItem('vidaplus_auth')
    if (storedAuth) {
      const { isLoggedIn, userType, userData } = JSON.parse(storedAuth)
      setIsLoggedIn(isLoggedIn)
      setUserType(userType)
      setUserData(userData)
    }
  }, [])

  const login = (type, data = {}) => {
    const authData = {
      isLoggedIn: true,
      userType: type,
      userData: data
    }

    setIsLoggedIn(true)
    setUserType(type)
    setUserData(data)

    localStorage.setItem('vidaplus_auth', JSON.stringify(authData))
  }

  const logout = () => {
    setIsLoggedIn(false)
    setUserType(null)
    setUserData(null)

    localStorage.removeItem('vidaplus_auth')
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, userType, userData, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('deve ser usado com AuthProvider')
  }
  return context
}
